import { UPDATE_USERS_SUCCESS } from "../Users/actionTypes"
import { LOGIN, LOGIN_SUCCESS, LOGIN_FAILED, REFRESH_TOKEN, REFRESH_TOKEN_SUCCESS, REFERSH_TOKEN_FAILED, FEATURES, FEATURES_SUCCESS, FEATURES_FAILED, MODULES, MODULES_SUCCESS, MODULES_FAILED, UPDATE_USER, UPDATE_USER_FAILED, PERMISSIONS, PERMISSIONS_SUCCESS, PERMISSIONS_FAILED } from "./actionTypes"

const localUser = JSON.parse(localStorage.getItem('user'))

let initialState = {
    user: {},
    features: [],
    modules: [],
    permissions: [],
    loading: false,
    success: false,
    error: ''
}

if (localUser) {
    initialState.user = localUser
    initialState.success = true
}

export const authenticationReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN: return {
            ...state,
            user: {},
            loading: true,
            success: false,
            error: ''
        }
        case LOGIN_SUCCESS: return {
            ...state,
            user: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_USERS_SUCCESS: return {
            ...state,
            user: action.payload.updateLocalStorage ? {
                ...state.user,
                ...action.payload.response
            } : state.user,
            loading: false,
            success: true,
            error: ''
        }

        case LOGIN_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case REFRESH_TOKEN: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case REFRESH_TOKEN_SUCCESS: return {
            ...state,
            user: {
                ...state.user,
                accessToken: action.payload
            },
            loading: false,
            success: true
        }
        case REFERSH_TOKEN_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case FEATURES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case FEATURES_SUCCESS: return {
            ...state,
            features: action.payload,
            loading: false,
            success: true
        }
        case FEATURES_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case MODULES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case MODULES_SUCCESS: return {
            ...state,
            modules: action.payload,
            loading: false,
            success: true
        }
        case MODULES_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case PERMISSIONS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case PERMISSIONS_SUCCESS: return {
            ...state,
            permissions: action.payload,
            user: {
                ...state.user,
                role: {
                    ...state.user.role,
                    permissions_role: action.payload
                }
            },
            loading: false,
            success: true
        }
        case PERMISSIONS_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        default: return state
    }
}